import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BrandMark, IconArrow, IconMenu } from './icons';

const NAV = [
  { to: '/', label: 'Início', end: true },
  { to: '/quem-somos', label: 'Quem somos' },
  { to: '/objetivo', label: 'Objetivo' },
  { to: '/planos', label: 'Planos' },
];

export default function CommercialHeader() {
  const [stuck, setStuck] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`cc-header${stuck ? ' is-stuck' : ''}`}>
      <div className="cc-wrap cc-header-in">
        <Link to="/" className="cc-brand" onClick={() => setOpen(false)}>
          <span className="cc-brand-mark" style={{ color: 'var(--cc-gold)' }}><BrandMark /></span>
          <span>
            <span className="cc-brand-name">Cloud Café <span className="cc-amp">&amp;</span> DevOps</span>
            <span className="cc-brand-sub">treinamentos</span>
          </span>
        </Link>

        <nav className="cc-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `cc-nav-link${isActive ? ' is-active' : ''}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="cc-header-cta">
          <Link className="cc-btn cc-btn-ghost cc-btn-sm" to="/treinamentos">Entrar</Link>
          <Link className="cc-btn cc-btn-primary cc-btn-sm" to="/treinamentos/cadastro">
            Começar grátis <IconArrow size={16} />
          </Link>
          <button className="cc-burger" aria-label="Abrir menu" onClick={() => setOpen((v) => !v)}>
            <IconMenu />
          </button>
        </div>
      </div>

      {open && (
        <div className="cc-mobile">
          <div className="cc-wrap">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className="cc-mobile-link" onClick={() => setOpen(false)}>
                {n.label}
              </NavLink>
            ))}
            <Link className="cc-btn cc-btn-ghost cc-mobile-btn" to="/treinamentos" onClick={() => setOpen(false)}>Entrar</Link>
            <Link className="cc-btn cc-btn-primary cc-mobile-btn" to="/treinamentos/cadastro" onClick={() => setOpen(false)}>Começar grátis</Link>
          </div>
        </div>
      )}
    </header>
  );
}
